import React from "react";
import { Label } from "@/components/ui/label";

export function Panel({ title, subtitle, children, actions }) {
  return (
    <section className="rounded-2xl bg-white dark:bg-slate-900 border border-border p-6 shadow-[0_2px_10px_rgb(0,0,0,0.03)]">
      {(title || actions) && (
        <div className="flex items-start justify-between mb-5 gap-3">
          <div>
            {title && <h2 className="font-heading font-bold text-base">{title}</h2>}
            {subtitle && <p className="text-xs text-muted-foreground mt-1">{subtitle}</p>}
          </div>
          {actions && <div className="flex items-center gap-2 shrink-0">{actions}</div>}
        </div>
      )}
      {children}
    </section>
  );
}

export function Field({ label, hint, className = "", children }) {
  return (
    <div className={className}>
      <Label className="text-xs font-medium text-slate-700 dark:text-slate-300 mb-1.5 block">{label}</Label>
      {children}
      {hint && <p className="text-[10px] text-muted-foreground mt-1">{hint}</p>}
    </div>
  );
}
